import AdminPublicDbSearchResult from "./adminPublicDbSearchResult"

export const AdminDb = () => {
    return (
        <>
        <AdminPublicDbSearchResult />
        </>
        
    )    
}

export default AdminDb;